import React from "react";

const API_KEY = "8c9f03c67859f437a5f341aaf2ea60a5";


export default  API_KEY;